<div [formGroup]="$any(formArray)" class="mt-2 mb-3">
  @for (
    rule of regimeDepreciationRules;
    track rule;
    let i = $index;
    let last = $last
  ) {
    @if (isValidRuleForDate(rule)) {
      <app-form-control
        [formGroupName]="i"
        [class.opacity-75]="!isValidRule(rule, formGroup.value)"
        [columnLayout]="true"
        margin="small"
      >
        <div class="checkbox-enhanced">
          <input
            data-dd-action-name="depreciation-rule-selector.use-rule-checkbox"
            id="use-rule-{{ rule.id }}"
            type="checkbox"
            appControlEnable
            authorizeEnable
            [authorizeRegister]="RegisterPermissionType.UpdateAsset"
          />
          <label
            for="use-rule-{{ rule.id }}"
            [class.text-black-50]="!isValidRule(rule, formGroup.value)"
          >
            {{ getRuleLabel(rule, formGroup.value) }}
          </label>
        </div>
      </app-form-control>
    }
  }
</div>
